var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploader"},[_vm._t("default",[_c('uploader-unsupport'),_c('uploader-drop',[_c('uploader-btn',[_vm._v("上传文件")])],1),_c('uploader-list')],{"files":_vm.files,"fileList":_vm.fileList,"started":_vm.started})],2)}
var staticRenderFns = []

export { render, staticRenderFns }